<template>
    <SbsFaIcon
        class="sbs-icon"
        :class="iconClasses"
        :style="iconStyles"
        v-bind="$props" />
</template>

<script>
import dimensionsMixin from '../../mixins/dimensions.js';
import themesMixin from '../../mixins/themes.js';
import { isArrayContainsValue } from '../../utils/validators.js';
import {
    AllSizes,
    APP_SIZES,
} from '../../utils/sizes.js';
import {
    AllIconGroups,
    ICON_GROUPS,
    ICON_ANIMATIONS,
} from './utils/consts.js';

const loadFAStyles = () => import('sbs-fa-icons/dist/SbsFaIcons.css');

/**
 * Компонент для иконок FontAwesome
 */
export default {
    name: 'SbsIcon',
    mixins: [dimensionsMixin, themesMixin],
    computed: {
        iconClasses() {
            const classes = [];

            if (this.iconSize) classes.push(this.iconSize);

            return [...classes, ...this.themeClasses];
        },
        iconStyles() {
            return {
                ...this.dimensionStyles,
            };
        },
    },
    props: {
        /**
         * Название класса, отвечающего за анимацию иконки
         */
        animation: {
            type: String,
            default: '',
            validator: value => !value || isArrayContainsValue(ICON_ANIMATIONS),
        },
        /**
         * Включение фиксированной ширины для любой иконки – `1.25em`
         */
        fixedWidth: {
            type: Boolean,
            default: false,
        },
        /**
         * Стиль (группа) иконки
         */
        iconGroup: {
            type: String,
            default: AllIconGroups.REGULAR,
            validator: isArrayContainsValue(ICON_GROUPS),
        },
        /**
         * Название иконки из FontAwesome.
         * Список всех иконок можно посмотреть [здесь](https://fontawesome.com/v6/icons)
         */
        iconName: {
            type: String,
            required: true,
        },
        /**
         * Размер иконки
         */
        iconSize: {
            type: String,
            default: AllSizes.MEDIUM,
            validator: isArrayContainsValue(APP_SIZES),
        },
    },
    created() {
        loadFAStyles();
    },
};
</script>

<style lang="scss">
.sbs-icon {
    &.x-small {
        font-size: 0.75em;
    }

    &.small {
        font-size: 0.875em;
    }

    &.medium {
        font-size: 1em;
    }

    &.large {
        font-size: 1.334em;
    }

    &.x-large {
        font-size: 2em;
    }

    &.xx-large {
        font-size: 3em;
    }

    &::before {
        line-height: 1;
    }
}
</style>
